module.exports = __webpack_public_path__ + "static/media/reminders mock.1ae2f26d.png";